<template>
    <div class="d-flex flex-row justify-content-center mb-3 report-summary">
        <counter v-bind:to="healthchecks.all" label="Total Healthchecks"></counter>
        <counter v-bind:to="healthchecks.month" label="This Month"></counter>
    </div>
</template>

<script>
    export default {
        name: "ReportHC",
        props: ['healthchecks','services']
    }
</script>

<style scoped>

</style>
